/**
 * Private routes
 */

import FunctionPageWrapper from '@/components/common/FunctionPageWrapper.vue';
import clientRoutes from '@/router/client';
import eventRoutes from '@/router/event';
import launchRoutes from '@/router/launch';
import learningRoutes from '@/router/learning';
import participationRoutes from '@/router/participation';
import profileRoutes from '@/router/personal-profile';
import RouterUtils from '@/utils/router';
import Dashboard from '@/views/Dashboard.vue';

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: [RouterUtils.checkLoginUser, RouterUtils.checkRunningModule, RouterUtils.resetHUBSettings],
  },

  // Function routes
  {
    // This path will not appear in url
    // functionPageWrapper is a logical container of function pages
    path: '/func',
    component: FunctionPageWrapper,
    children: [
      ...learningRoutes,
      ...clientRoutes,
      ...profileRoutes,
      /* Only for online */
      ...eventRoutes,
    ],
  },

  ...launchRoutes,
  ...participationRoutes,
];
